var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('responsive-container',{staticClass:"d-flex align-center",staticStyle:{"height":"100%"}},[_c('generic-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }